import trackAddToBag from "./trackAddToBag";
export { default as trackExperimentEvent } from "./trackExperimentEvent";

const initialiseOptimizelyTracking = () => {
  trackAddToBag();
};

export { initialiseOptimizelyTracking };
